import { Box, styled } from '@mui/material';

export const LeftBorder = styled(Box)({
  position: 'absolute',
  left: 0,
  top: 0,
  background: '#D32F2F',
  width: '2px',
  height: '100%',
});